export default "__VITE_ASSET__BNeK5DS1__"